import BasePolicy from '@/policies/BasePolicy.js';

export default class EbookPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('can access system ebooks');
    }

    hasAdminAccess(user) {
        return user;
    }
}
